import Tooltip from '@components/Tooltip';

function RecentToolTip() {
  return (
        <Tooltip visibleKey='signInMethod'
                 shape='line'
                 hideClose
                 top={-36}
                 right={0} >
            최근 로그인한 계정
        </Tooltip>
  );
}

export default RecentToolTip;
